import { createAction } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import {
  PARTICIPANT_SET_INFORMATION,
  PARTICIPANT_STATUS_FAILURE,
  PARTICIPANT_STATUS_REQUEST,
  PARTICIPANT_STATUS_REQUEST_AFTER_LOGIN_WITH_TOKEN,
  PARTICIPANT_STATUS_SUCCESS,
} from '@app/store/actionTypes';
import Status from '@app/store/document/Status';
import DocumentRole from '@app/store/documents/DocumentRole';
import Participant from '@app/store/documents/Participant';
import Signing from '@app/store/documents/Signing';
import Host from '@app/store/Host';

import { SigningMethodTypeState } from './reducers/signingMethodType';

export function setParticipantInformation(payload: {
  contactInfo?: string;
  host?: Host;
  documentId: string;
  linkKey?: string;
  signingMethodType?: 'email' | 'kakao' | 'IN_PERSON' | 'SECURE_LINK';
}) {
  return {
    type: PARTICIPANT_SET_INFORMATION,
    payload,
  };
}

interface LoginWithTokenParam {
  documentId: string;
  participantId: string;
  redirect?: boolean;
  // (Juyeong-Byeon) 로그인시 필요 값들.
  contactInfo: string;
  signingMethodType: 'email' | 'kakao' | 'SECURE_LINK' | 'IN_PERSON';
  linkKey: string | null;
  token: string | null;
  expiry?: number;
}

interface FetchParticipantStatusParam {
  documentId: string;
  participantId?: string;
  redirect?: boolean;
  exitPath?: string;
  isSigningRightNow?: boolean;
}

export const fetchParticipantStatusAfterLoginWithToken = createAction<
  LoginWithTokenParam,
  'PARTICIPANT_STATUS_REQUEST_AFTER_LOGIN_WITH_TOKEN'
>(PARTICIPANT_STATUS_REQUEST_AFTER_LOGIN_WITH_TOKEN);

export const fetchParticipantStatus = createAction<
  FetchParticipantStatusParam,
  'PARTICIPANT_STATUS_REQUEST'
>(PARTICIPANT_STATUS_REQUEST);

export interface FetchParticipantSuccessParam {
  exitPath?: string;
  isSigningRightNow?: boolean;
  participants: Participant[];
  redirect?: boolean;
  requester: {
    email: string;
    name: string;
  };
  signings: Signing[];
  status: Status;
  userRole: DocumentRole;
  host: Host | null;
  signer: {
    contactInfo: string;
    participantId: string;
    signingMethodType: SigningMethodTypeState;
  };
  currentSigningOrder: number;
}

export const fetchParticipantStatusSuccess = createAction<
  FetchParticipantSuccessParam,
  'PARTICIPANT_STATUS_SUCCESS'
>(PARTICIPANT_STATUS_SUCCESS);

export function fetchParticipantStatusFailure(payload: AxiosError) {
  return {
    type: PARTICIPANT_STATUS_FAILURE,
    payload,
  };
}

export type ParticipantAction =
  | ReturnType<typeof fetchParticipantStatus>
  | ReturnType<typeof fetchParticipantStatusAfterLoginWithToken>
  | ReturnType<typeof setParticipantInformation>
  | ReturnType<typeof fetchParticipantStatusSuccess>
  | ReturnType<typeof fetchParticipantStatusFailure>;
